const getCashbackStatuses = () => {
  return [
    { name: 'Created', value: 'created' },
    { name: 'Available', value: 'available' },
    { name: 'Pending', value: 'pending' },
    { name: 'Paid', value: 'paid' },
    { name: 'Declined', value: 'declined' },
    { name: 'Expired', value: 'expired' },
  ]
}

export { getCashbackStatuses }
